/* COBE size guide block (snippets/cobe-size-guide.liquid): modal + size calculator.
   Texts and the shop email come from data attributes on #sg-open-btn; the size table lives in DATA below. */
function initSizeGuide() {
    'use strict';

    /* Height bands per client (25 Sep): XS 145-158cm, S 155-165cm, M 163-173cm,
       L 170-190cm - same for both genders, only the dress/chest size columns
       differ. feet rows are the cm bounds converted to inches (round-to-nearest,
       matching the existing convention in this file). */
    var DATA = {
        female: {
            cm: [
                { size: 'XS',     hMin: 145, hMax: 158, mMin: 6,  mMax: 10 },
                { size: 'Small',  hMin: 155, hMax: 165, mMin: 8,  mMax: 12 },
                { size: 'Medium', hMin: 163, hMax: 173, mMin: 8,  mMax: 16 },
                { size: 'Large',  hMin: 170, hMax: 190, mMin: 8,  mMax: 20 }
            ],
            feet: [
                { size: 'XS',     hMin: 57, hMax: 62, mMin: 6,  mMax: 10 },
                { size: 'Small',  hMin: 61, hMax: 65, mMin: 8,  mMax: 12 },
                { size: 'Medium', hMin: 64, hMax: 68, mMin: 8,  mMax: 16 },
                { size: 'Large',  hMin: 67, hMax: 75, mMin: 8,  mMax: 20 }
            ]
        },
        male: {
            cm: [
                { size: 'XS',     hMin: 145, hMax: 158, mMin: 32, mMax: 36 },
                { size: 'Small',  hMin: 155, hMax: 165, mMin: 32, mMax: 40 },
                { size: 'Medium', hMin: 163, hMax: 173, mMin: 36, mMax: 44 },
                { size: 'Large',  hMin: 170, hMax: 190, mMin: 40, mMax: 48 }
            ],
            feet: [
                { size: 'XS',     hMin: 57, hMax: 62, mMin: 32, mMax: 36 },
                { size: 'Small',  hMin: 61, hMax: 65, mMin: 32, mMax: 40 },
                { size: 'Medium', hMin: 64, hMax: 68, mMin: 36, mMax: 44 },
                { size: 'Large',  hMin: 67, hMax: 75, mMin: 40, mMax: 48 }
            ]
        }
    };

    var CFG = {
        cm: {
            h: { min: 130, max: 210, step: 1, def: 170 },
            female: { min: 0,  max: 28, step: 2, def: 12, label: 'Dress Size' },
            male:   { min: 28, max: 60, step: 2, def: 40, label: 'Chest Size (in)' }
        },
        feet: {
            h: { min: 55, max: 80, step: 1, def: 67 },
            female: { min: 0,  max: 28, step: 2, def: 12, label: 'Dress Size' },
            male:   { min: 28, max: 60, step: 2, def: 40, label: 'Chest Size (in)' }
        }
    };

    var unit   = 'cm';
    var gender = 'female';
    var fit    = 'regular';

    var openBtn  = document.getElementById('sg-open-btn');
    var overlay  = document.getElementById('sg-overlay');
    if (!openBtn || !overlay) return;
    var TEXT = {
        email: openBtn.dataset.shopEmail || '',
        resultLabel: openBtn.dataset.resultLabel || 'Your recommended size',
        errorTitle: openBtn.dataset.errorTitle || 'Size not found',
        errorText: openBtn.dataset.errorText || 'Currently we are unable to calculate your size, please contact us and we\'ll help you choose.'
    };

    /* Move the overlay to <body> to escape parent stacking contexts (transform/filter/will-change).
       A previous instance (theme editor re-render) is removed first. */
    document.querySelectorAll('body > #sg-overlay').forEach(function (old) { if (old !== overlay) old.remove(); });
    document.body.appendChild(overlay);
    var closeBtn = document.getElementById('sg-close-btn');
    var hRange   = document.getElementById('sg-h-range');
    var mRange   = document.getElementById('sg-m-range');
    var hTip     = document.getElementById('sg-h-tip');
    var mTip     = document.getElementById('sg-m-tip');
    var hBadge   = document.getElementById('sg-h-badge');
    var mBadge   = document.getElementById('sg-m-badge');
    var hMinLbl  = document.getElementById('sg-h-min-lbl');
    var hMaxLbl  = document.getElementById('sg-h-max-lbl');
    var mMinLbl  = document.getElementById('sg-m-min-lbl');
    var mMaxLbl  = document.getElementById('sg-m-max-lbl');
    var mLabel   = document.getElementById('sg-m-label');
    var resultEl = document.getElementById('sg-result');
    var calcBtn  = document.getElementById('sg-calc-btn');

    function toFeetStr(totalInches) {
        totalInches = parseInt(totalInches);
        var ft   = Math.floor(totalInches / 12);
        var inch = totalInches % 12;
        return inch === 0 ? ft + 'ft' : ft + 'ft ' + inch + 'in';
    }

    function hDisplay(val) {
        return unit === 'feet' ? toFeetStr(val) : val + ' cm';
    }

    function setFill(range) {
        var pct = (range.value - range.min) / (range.max - range.min) * 100;
        range.style.setProperty('--fill', pct.toFixed(1) + '%');
    }

    function placeTip(range, tip) {
        var pct    = (range.value - range.min) / (range.max - range.min);
        var w      = range.offsetWidth;
        if (!w) return;
        var thumbR = 11;
        var left   = pct * (w - thumbR * 2) + thumbR;
        tip.style.left = left + 'px';
    }

    function syncH() {
        var disp = hDisplay(hRange.value);
        hTip.textContent   = disp;
        hBadge.textContent = disp;
        setFill(hRange);
        placeTip(hRange, hTip);
    }

    function syncM() {
        var v = mRange.value;
        mTip.textContent   = v;
        mBadge.textContent = v;
        setFill(mRange);
        placeTip(mRange, mTip);
    }

    function layoutTips() {
        placeTip(hRange, hTip);
        placeTip(mRange, mTip);
    }

    function applyConfig() {
        var hc = CFG[unit].h;
        var mc = CFG[unit][gender];

        hRange.min   = hc.min;
        hRange.max   = hc.max;
        hRange.step  = hc.step;
        hRange.value = hc.def;
        hMinLbl.textContent = hDisplay(hc.min);
        hMaxLbl.textContent = hDisplay(hc.max);

        mRange.min   = mc.min;
        mRange.max   = mc.max;
        mRange.step  = mc.step;
        mRange.value = mc.def;
        mLabel.textContent  = mc.label;
        mMinLbl.textContent = mc.min;
        mMaxLbl.textContent = mc.max;

        syncH();
        syncM();
        hideResult();
    }

    function hideResult() {
        resultEl.className = 'sg-result';
        resultEl.innerHTML = '';
    }

    function calculate() {
        var h    = parseInt(hRange.value);
        var m    = parseInt(mRange.value);
        var list = DATA[gender][unit];

        var matches = list.filter(function (s) {
            return h >= s.hMin && h <= s.hMax && m >= s.mMin && m <= s.mMax;
        });

        if (matches.length === 0) {
            renderError();
        } else {
            var chosen = fit === 'oversize' ? matches[matches.length - 1] : matches[0];
            renderSuccess(chosen.size);
        }
    }

    function renderSuccess(size) {
        resultEl.innerHTML =
            '<div class="sg-result-ok">' +
                '<div class="sg-result-ok-icon">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
                        '<polyline points="20 6 9 17 4 12"/>' +
                    '</svg>' +
                '</div>' +
                '<div class="sg-result-ok-body">' +
                    '<div class="sg-result-ok-label">' + TEXT.resultLabel + '</div>' +
                    '<div class="sg-result-ok-size">' + size + '</div>' +
                '</div>' +
            '</div>';
        resultEl.className = 'sg-result sg-visible';
    }

    function renderError() {
        var email = TEXT.email;
        resultEl.innerHTML =
            '<div class="sg-result-err">' +
                '<div class="sg-result-err-title">' +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F1AB4A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
                        '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>' +
                    '</svg>' +
                    TEXT.errorTitle +
                '</div>' +
                '<p>' + TEXT.errorText + '<br>' +
                '<a href="mailto:' + email + '">' + email + '</a></p>' +
            '</div>';
        resultEl.className = 'sg-result sg-visible';
    }

    function openModal() {
        overlay.classList.add('sg-open');
        document.body.style.overflow = 'hidden';
        applyConfig();
        requestAnimationFrame(function () {
            requestAnimationFrame(layoutTips);
        });
    }

    function closeModal() {
        overlay.classList.remove('sg-open');
        document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('sg-open')) closeModal();
    });

    document.querySelectorAll('.sg-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
            document.querySelectorAll('.sg-tab').forEach(function (b) {
                b.classList.remove('active');
                b.setAttribute('aria-selected', 'false');
            });
            this.classList.add('active');
            this.setAttribute('aria-selected', 'true');
            var isCalc = this.dataset.tab === 'calc';
            document.getElementById('sg-panel-calc').classList.toggle('sg-hidden', !isCalc);
            document.getElementById('sg-panel-guide').classList.toggle('sg-hidden', isCalc);
        });
    });

    document.querySelectorAll('.sg-metric').forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (unit === this.dataset.unit) return;
            unit = this.dataset.unit;
            document.querySelectorAll('.sg-metric').forEach(function (b) { b.classList.remove('active'); });
            this.classList.add('active');
            applyConfig();
            requestAnimationFrame(layoutTips);
        });
    });

    document.querySelectorAll('.sg-gender').forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (gender === this.dataset.gender) return;
            gender = this.dataset.gender;
            document.querySelectorAll('.sg-gender').forEach(function (b) { b.classList.remove('active'); });
            this.classList.add('active');
            applyConfig();
            requestAnimationFrame(layoutTips);
        });
    });

    document.querySelectorAll('.sg-fit').forEach(function (btn) {
        btn.addEventListener('click', function () {
            fit = this.dataset.fit;
            document.querySelectorAll('.sg-fit').forEach(function (b) { b.classList.remove('active'); });
            this.classList.add('active');
        });
    });

    hRange.addEventListener('input', syncH);
    mRange.addEventListener('input', syncM);
    calcBtn.addEventListener('click', calculate);
}

initSizeGuide();
/* The theme editor re-renders the section when a setting changes */
document.addEventListener('shopify:section:load', initSizeGuide);
